import {ActiveField} from '../ActiveField'

export default class StringField extends ActiveField {
  constructor () {
    // @ts-ignore
    super(...arguments)
    this.fieldType = 'textarea'
  }
}